import { ComponentProps, Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';

import LogoMark from '@/assets/svg/logos/logo-mark.svg';
import CircleHelpIcon from '@/assets/svg/ui-elements/circle-help.svg';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { GAMMA_PRIME_EMAIL } from '@/shared/constants/social-links';
import { IconButton, TextButton } from '@/shared/design-system';

import { GeneralLoadingFallback } from '../general-loading-fallback';
import { JourneyRail } from './journey-rail';
import { LogoutButton } from './logout-confirm';
import { JourneyState, QuestionnaireJourneyContext } from './questionnaire-journey-context';
import { StyledFormSide, StyledMobileHeader, StyledPage, StyledUtilityLinks } from './styled';

const LOGO_SIZE = 32;

const renderHelpLink = (props: ComponentProps<'a'>) => (
  <a {...props} href={GAMMA_PRIME_EMAIL} aria-label="Help" />
);

export const QuestionnaireLayout = () => {
  const isMobile = useIsMobile();
  const [journey, setJourney] = useState<JourneyState>('profileInProgress');
  const [step, setStep] = useState<number | null>(null);

  return (
    <QuestionnaireJourneyContext.Provider
      value={{ state: journey, setState: setJourney, step, setStep }}
    >
      <StyledPage>
        {isMobile ? (
          <StyledMobileHeader>
            <LogoMark width={LOGO_SIZE} height={LOGO_SIZE} aria-label="Gamma Prime" role="img" />
            <IconButton
              aria-label="Help"
              variant="solid"
              color="tertiary"
              size="xs"
              nativeButton={false}
              render={renderHelpLink}
            >
              <CircleHelpIcon />
            </IconButton>
          </StyledMobileHeader>
        ) : (
          <JourneyRail />
        )}

        <StyledFormSide>
          {!isMobile && (
            <StyledUtilityLinks>
              <TextButton nativeButton={false} render={renderHelpLink}>
                Help
              </TextButton>
              <LogoutButton />
            </StyledUtilityLinks>
          )}
          <Suspense fallback={<GeneralLoadingFallback />}>
            <Outlet />
          </Suspense>
        </StyledFormSide>
      </StyledPage>
    </QuestionnaireJourneyContext.Provider>
  );
};
